var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-application',[_c('v-layout',{staticClass:"mx-2",attrs:{"row":""}},[_c('v-flex',{staticClass:"px-2 pt-2",attrs:{"md6":""}},[_c('v-card',{attrs:{"tile":"","outlined":""}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }